import produce from 'immer';

import {
  REQUEST_NEWS,
  REQUEST_NEWS_SUCCESS,
  REQUEST_NEWS_ERROR,
  GET_SINGLE_NEWS,
  GET_SINGLE_NEWS_SUCCESS,
  GET_SINGLE_NEWS_ERROR,
  REQUEST_NEWS_BY_CATEGORY,
  GET_MOST_READ_NEWS_BY_CATEGORY,
  GET_MOST_READ_NEWS_BY_CATEGORY_SUCCESS,
  MOST_READ_NEWS,
  MOST_READ_NEWS_SUCCESS,
  EDIT_NEWS,
  EDIT_NEWS_ERROR,
  EDIT_NEWS_SUCCESS,
  NEWS_CLOSE_SUCCES_MODAL
} from './constants';

import {NewsItem} from '../../models/newsItem';

// Interface
export interface newsState {
  loading: boolean;
  loadingButton: boolean;
  error: any;
  news: NewsItem[];
  newsItem : object | null;
  page: number;
  currentPage: number;
  pageCount: number;
  modal: {
    success: boolean
  };
  pageMostReadNewsCount: number;
  currentMostReadNewsPage: number;
  loaderMostReadNews: boolean;
  mostReadNews: [];
}

export const initialState: newsState = {
  loading: false,
  loadingButton: false,
  error: null,
  news: [],
  newsItem: null,
  page: 1,
  currentPage: 1,
  pageCount: 1,
  modal: {
    success: false
  },
  pageMostReadNewsCount: 1,
  currentMostReadNewsPage: 1,
  loaderMostReadNews: false,
  mostReadNews: []
};

/* eslint-disable default-case, no-param-reassign */
const newsReducer = (state = initialState, action: any) =>
  produce(state, draft => {
    switch (action.type) {
      case REQUEST_NEWS:
        draft.loading = true;
        draft.news = [];
        break;
      case REQUEST_NEWS_SUCCESS:       
        draft.loading = false;
        draft.currentPage = action?.response?.data?.meta?.current_page || 1;
        draft.pageCount = action?.response?.data?.meta?.last_page || 1;
        draft.news = action.response.data.data;
        break;
      case REQUEST_NEWS_ERROR:
        draft.loading = false;
        draft.error = action.error.response ? action.error.response.status : 0;
        break;
      case MOST_READ_NEWS:
        draft.loaderMostReadNews = true;
        draft.mostReadNews = [];
        break;
      case MOST_READ_NEWS_SUCCESS:
        draft.loaderMostReadNews = false;
        draft.currentMostReadNewsPage = action?.response?.data?.meta?.current_page || 1;
        draft.pageMostReadNewsCount = action?.response?.data?.meta?.last_page || 1;
        draft.mostReadNews = action.response.data.data;
        break;
      case GET_SINGLE_NEWS:
        draft.loading = true;
        draft.newsItem = null;
        break;
      case GET_SINGLE_NEWS_SUCCESS:
        draft.newsItem = action.response.data;
        draft.loading = false;
        draft.error = null;
        break;
      case GET_SINGLE_NEWS_ERROR:
        draft.newsItem = null;
        draft.loading = false;
        draft.error = action.error.response ? action.error.response.status : 0;
        break;
      case REQUEST_NEWS_BY_CATEGORY:
        draft.page = 1;
        break;  
      case GET_MOST_READ_NEWS_BY_CATEGORY:
        draft.loaderMostReadNews = true;
        break;
      case GET_MOST_READ_NEWS_BY_CATEGORY_SUCCESS:
        draft.loaderMostReadNews = false;
        draft.currentMostReadNewsPage = action?.response?.data?.meta?.current_page || 1;
        draft.pageMostReadNewsCount = action?.response?.data?.meta?.last_page || 1;
        draft.news = action.response.data.data;
        break;
      case EDIT_NEWS:
        draft.loadingButton = true;
        draft.error = null;
        break;
      case EDIT_NEWS_SUCCESS:
        draft.loadingButton = false;
        break;   
      case EDIT_NEWS_ERROR:
        draft.loadingButton = false;
        draft.error = action.error.response ? action.error.response.status : "Unknown error";
        break;
      case NEWS_CLOSE_SUCCES_MODAL:
        draft.modal.success = action.open;
        break;
    }
  });

export default newsReducer;
